import axios from "config/axios/base";
import qs from "qs";

export const getOrders = ({ query = {}, options = null }) => axios.get(`/orders?${qs.stringify(query)}`, options);
export const updateOrders = ({ params = {}, body = {}, options = null }) =>
	axios.patch(`/orders/${params?.id}`, body, options);
export const getPhysicianOrders = ({ query = {}, options = null }) =>
	axios.get(`/physician-orders?${qs.stringify(query)}`, options);
export const postRxOrder = ({ params = {}, body = {}, options = null }) =>
	axios.post(`/orders/${params?.id}/rx-order`, body, options);

export const addRemark = ({ params = {}, body = {}, options = null, type = "order" }) => {
	if (type === "order") {
		return axios.post(`/orders/${params?.id}/remark-threads`, body, options);
	} else if (type === "referral") {
		return axios.post(`/internal-referral/remark-threads/${params?.id}`, body, options);
	}
};

export const getRemarkThreads = ({ params = {}, query = {}, options = null, type = "order" }) => {
	if (type === "order") {
		return axios.get(`/orders/${params?.id}/remark-threads?${qs.stringify(query)}`, options);
	} else if (type === "referral") {
		return axios.get(`/internal-referral/remark-threads/${params?.id}?${qs.stringify(query)}`, options);
	}
};

export const getRemarkUnreadCount = ({ params = {}, options = null, type = "order" }) => {
	if (type === "order") {
		return axios.get(`/orders/${params?.id}/remark-threads/unread-count`, options);
	} else if (type === "referral") {
		return axios.get(`/internal-referral/remark-threads/${params?.id}/get-unread-count`, options);
	} else if (type === "electronic_form_order") {
		return axios.get(`/electronic-form-orders/${params?.id}/remark-threads/unread-count`, options);
	}
};

export const addRemarkReply = ({ params = {}, body = {}, options = null, type = "order" }) => {
	if (type === "order") {
		return axios.post(`/orders/${params?.id}/remark-threads/${params?.remark_thread_id}/replies`, body, options);
	} else if (type === "referral") {
		return axios.post(
			`/internal-referral/remark-threads/${params?.id}/replies/${params?.remark_thread_id}`,
			body,
			options
		);
	}
};

// Saved remarks endpoints
export const getSavedRemarks = ({ query = {}, options = null, type = "order" }) => {
	if (type === "order") {
		return axios.get(`/orders/saved-remarks?${qs.stringify(query)}`, options);
	} else if (type === "referral") {
		return axios.get(`/internal-referral/saved-remarks?${qs.stringify(query)}`, options);
	}
};

export const deleteSavedRemark = ({ params = {}, options = null, type = "order" }) => {
	if (type === "order") {
		return axios.delete(`/orders/saved-remarks/${params?.id}`, options);
	} else if (type === "referral") {
		return axios.delete(`/internal-referral/saved-remarks/${params?.id}`, options);
	}
};

/** E-form requisition edit: draft lock, can_edit, and revision (GET by order / note id). */
export const getRequisitionOrderEditEligibility = ({ params = {}, options = null }) =>
	axios.get(`/orders/${params?.id}/edit-eligibility`, options);

export const postOrderSubmitUpdate = ({ params = {}, body = {}, options = null }) =>
	axios.post(`/orders/${params?.id}/submit-update`, body, options);

export const postOrderRetryUpdate = ({ params = {}, body = {}, options = null }) =>
	axios.post(`/orders/${params?.id}/retry-update`, body, options);

/** Re-run fillable PDF + Vaulto for a published revision (failed or pending PDF). */
export const postOrderRetryOrderPdf = ({ params = {}, body = {}, options = null }) =>
	axios.post(`/orders/${params?.id}/retry-order-pdf`, body || {}, options);

export const deleteOrderRequisitionDraft = ({ params = {}, options = null }) =>
	axios.delete(`/orders/${params?.id}/requisition-draft`, options);

export const getOrderAmendments = ({ params = {}, query = {}, options = null }) => {
	const q = Object.keys(query).length > 0 ? `?${qs.stringify(query)}` : "";
	return axios.get(`/orders/${params?.id}/amendments${q}`, options);
};
